import React from 'react'
import WelcomeBackground from './WelcomeBackground'
import { useNavigate } from 'react-router-dom';
export default function WelcomePage() {
  const navigate = useNavigate();
  return (
    <>
      <WelcomeBackground />
      <div class="container-fluid">
        <div class="row">
          <div class="text-center">
            <h3 style={{marginLeft:"5px"}} class="animate-charcter">welcome to i-notes</h3>
            <br />
            <button class="button-73"  onClick={()=>{ navigate('/MainWebPage', { replace: true }) }}>Let's get started</button>
            <br />
          </div>
        </div>
      </div>
    </>
  )
}
